import { buildMarkdown } from '../../components/bug-management/BugReport'
import { isResolved } from '../../../netlify/functions/lib/bug-management/statuses'
import type { Bug } from '../../data/projectTypes'

// Builds a single markdown document from the RTK Query pages loaded by the caller, oldest-first.
// Keeping this function pure means copying reports does not create a second fetching or caching path.
export function buildOpenBugsMarkdown(allBugs: Bug[]): string {
  const openBugs = allBugs.filter(bug => !isResolved(bug.status))
  openBugs.sort((a, b) => new Date(a.discovered_at).getTime() - new Date(b.discovered_at).getTime())
  return openBugs.map(bug => buildMarkdown(bug)).join('\n\n---\n\n')
}
